// context/todoContext.tsx
import { startOfWeek } from 'date-fns';
import { formatInTimeZone } from 'date-fns-tz';
import * as React from 'react';
import { useState } from 'react';
import { useAppSelector } from '../../hooks/useRedux';

export type CalenderContextType = {
  today: Date;
  updateToday: (value: React.SetStateAction<Date>) => void;
  darkMode: boolean;
  setDarkMode: any;
};

export const CalenderContext = React.createContext<CalenderContextType | null>(null);

const CalenderProvider = ({ children }: { children: JSX.Element }) => {
  const { timezone } = useAppSelector((state) => state.preferencesSlice);
  const [today, setToday] = useState(
    new Date(formatInTimeZone(startOfWeek(new Date()), timezone, 'yyyy-MM-dd HH:mm:ssxxx'))
  );
  const [darkMode, setDarkMode] = useState(true);

  const updateToday = (value: React.SetStateAction<Date>) => {
    setToday(value);
  };

  return (
    <CalenderContext.Provider value={{ today, updateToday, darkMode, setDarkMode }}>
      {' '}
      {children}{' '}
    </CalenderContext.Provider>
  );
};

export default CalenderProvider;
